// extracted by mini-css-extract-plugin
module.exports = {"Header__skeleton":"Header_Header__skeleton__MMLxq","fadeInKeyframe":"Header_fadeInKeyframe__2TdZD"};